import { render, staticRenderFns } from "./comp_Hook-OfferItem-Discount.vue?vue&type=template&id=86f108d0&scoped=true&"
import script from "./comp_Hook-OfferItem-Discount.vue?vue&type=script&lang=js&"
export * from "./comp_Hook-OfferItem-Discount.vue?vue&type=script&lang=js&"
import style0 from "./comp_Hook-OfferItem-Discount.vue?vue&type=style&index=0&id=86f108d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f108d0",
  null
  
)

export default component.exports